import { Link } from "react-router-dom";
import { Phone, CalendarClock } from "lucide-react";
import { SITE } from "@/config/site";
import { trackEvent } from "@/lib/analytics";

export const MobileBottomBar = () => (
  <div
    data-testid="mobile-bottom-bar"
    className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white border-t border-gray-200 shadow-[0_-8px_30px_rgba(0,0,0,0.1)] px-3 py-3 flex gap-3"
    style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
  >
    <a
      href={SITE.phoneHref}
      onClick={() => trackEvent("click_phone", { location: "mobile_bar" })}
      data-testid="mobilebar-call-btn"
      className="flex-1 inline-flex items-center justify-center gap-2 py-3 rounded-full border-2 border-brand-black text-brand-black font-bold text-sm"
    >
      <Phone className="w-4 h-4" /> Appeler
    </a>
    <Link
      to="/contact"
      data-testid="mobilebar-intervention-btn"
      className="flex-1 inline-flex items-center justify-center gap-2 py-3 rounded-full bg-brand-gold text-brand-black font-bold text-sm"
    >
      <CalendarClock className="w-4 h-4" /> Intervention
    </Link>
  </div>
);
